import { useNavigate, useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import { useRegisterAttendance } from "../api/registerAttendance";

import {
  CardMedia,
  Box,
  Container,
  Avatar,
  Typography,
  Grid,
  Button,
} from "@mui/material";
import { useTheme } from "@emotion/react";
import { useCheckInEventLink } from "../api/getCheckInEventLink";
import { useEventInfo } from "../../events/api/getEventInfo";
import { baseUrl } from "../../../shared/config";

import moment from "moment";

import Navbar from "../../../ui/blocks/Navbar";
import { makeStyles } from "@mui/styles";
import {
  getZoomContent,
  useZoomContent,
} from "../../events/utils/getZoomContent";
import { createNotification } from "../../../shared/store/notifications";

const BASE_MEET_URL = "https://meet.cadernovirtual.com.br/room/";

const DATE_FORMAT = "DD/MM/YYYY HH:mm";

const useStyles = makeStyles((theme) => ({
  EmbeddedWrapper: {
    display: "flex",
    flexDirection: "row",
    [theme.breakpoints.down("md")]: {
      flexDirection: "column",
    },
  },
  EmbeddedContent: {
    aspectRatio: "16 / 9",
    width: "100%",
    height: "max-content",
    overflow: "auto",
    backgroundColor: theme.palette.menu.background || "#D3D3D3",
  },
  EmbeddedChat: {
    [theme.breakpoints.down("md")]: {
      height: "60vh",
    },
  },
}));

const eventMoments = (event) => {
  const now = moment(new Date());
  const checkInStartAtDate = moment(
    event?.inicio_checkin,
    "YYYY-MM-DD[T]HH:mm:ss"
  );
  const checkInEndsAtDate = moment(event?.fim_checkin, "YYYY-MM-DD[T]HH:mm:ss");

  const checkInHasEnded = now.isAfter(checkInEndsAtDate);
  const checkInWillHappen = now.isBefore(checkInStartAtDate);
  const checkInIsHappening = !checkInWillHappen && !checkInHasEnded;

  const eventStartsAt = moment(
    event?.live_datahora_inicio,
    "YYYY-MM-DD[T]HH:mm:ss"
  );
  const eventEndsAt = moment(
    event?.live_datahora_inicio,
    "YYYY-MM-DD[T]HH:mm:ss"
  );

  eventEndsAt.add(event?.live_duracao_aproximada_minutos, "minutes");

  const eventHasEnded = now.isAfter(eventEndsAt);
  const eventWillHappen = now.isBefore(eventStartsAt);
  const eventIsHappening = !eventWillHappen && !eventHasEnded;

  return {
    checkInStartAtDate,
    checkInEndsAtDate,
    checkInHasEnded,
    checkInWillHappen,
    checkInIsHappening,
    eventStartsAt,
    eventEndsAt,
    eventHasEnded,
    eventWillHappen,
    eventIsHappening,
  };
};

const WarningWrapper = ({ children }) => {
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "row",
        justifyContent: "center",
      }}
    >
      <Typography
        sx={{ display: "block", ml: "auto", mr: "auto", mt: 5 }}
        variant="h5"
        color="gray"
      >
        {children}
      </Typography>
    </Box>
  );
};

const PreRegisterWarnings = ({ contentType, url, eventMoments, eventInfo }) => {
  const {
    checkInIsHappening,

    eventWillHappen,
    eventHasEnded,
  } = eventMoments;

  if (checkInIsHappening && eventHasEnded) {
    return (
      <WarningWrapper>
        Esse evento acabou, mas você ainda pode registrar presença!
      </WarningWrapper>
    );
  } else if (checkInIsHappening && eventWillHappen) {
    return (
      <WarningWrapper>
        Esse evento ainda não começou, mas você já pode registrar presença!
      </WarningWrapper>
    );
  } else {
    return <></>;
  }
};

const RenderContents = ({
  contentType,
  eventType,
  url,
  eventMoments,
  eventInfo,
  isContentRewatchable,
}) => {
  const classes = useStyles();
  const { checkInIsHappening, eventIsHappening, eventHasEnded } = eventMoments;
  const theme = useTheme();
  console.log({ eventType });
  // const zoomContentQ = useZoomContent({
  //   eventId: eventInfo?.eventId,
  //   eventType,
  //   secretKey: eventInfo?.zoom_account,
  //   config: {
  //     enabled: contentType.toLocaleUpperCase() === "ZOOM",
  //     onSuccess: (data) => {
  //       console.log("sucesso");
  //       window.open(
  //         data,
  //         "ZoomSala",
  //         `width=1200,height=800,left=${(window.screen.width - 1200) / 2},top=${
  //           (window.screen.height - 800) / 2
  //         },menu=no,toolbar=no`
  //       );
  //     },
  //   },
  // });

  if (checkInIsHappening && !eventIsHappening) {
    return (
      <WarningWrapper>
        O evento {eventHasEnded ? "já terminou" : "ainda não começou"} mas sua
        presença já foi registrada!
      </WarningWrapper>
    );
  }
  if (eventHasEnded && !isContentRewatchable) {
    return (
      <WarningWrapper>Esse conteúdo não está mais acessível</WarningWrapper>
    );
  }

  switch (contentType.toLocaleUpperCase()) {
    case "PRESENCIAL":
      return <WarningWrapper>Sua presença foi registrada</WarningWrapper>;

    case "ZOOM":
      return <div className={classes.EmbeddedWrapper} same></div>;
    case "VIDEO":
      return (
        <div className={classes.EmbeddedWrapper}>
          <iframe
            className={classes.EmbeddedContent}
            src={`${url}`}
            title="content"
            SameSite="none"
          />
          {Boolean(eventInfo?.live_embed_chat) && (
            <iframe
              className={classes.EmbeddedChat}
              src={eventInfo.live_embed_chat}
              title="chat"
            />
          )}
        </div>
      );

    case "EMBEDDED":
      return (
        <div className={classes.EmbeddedWrapper}>
          <iframe
            className={classes.EmbeddedContent}
            src={`${url + "?controls=0"}`}
            title="content"
            SameSite="none"
          />
          {Boolean(eventInfo?.live_embed_chat) && (
            <iframe
              className={classes.EmbeddedChat}
              src={eventInfo.live_embed_chat}
              title="chat"
            />
          )}
        </div>
      );

    case "ANYMEET":
      return (
        <CardMedia
          sx={{
            width: "100%",
            height: "90%",
            backgroundColor: theme.palette.menu.background || "#D3D3D3",
          }}
          component="iframe"
          src={`${BASE_MEET_URL}${url}`}
          allow={
            "camera " +
            BASE_MEET_URL +
            "; microphone " +
            BASE_MEET_URL +
            "; display-capture " +
            BASE_MEET_URL
          }
        />
      );
    default:
      return <></>;
  }
};

const AttendanceRegistrationpage = () => {
  useEffect(() => {
    // document.getElementById("navbar_container").style.position = "fixed";
    // document.getElementById("navbar_container").style.top = "64px";
    // document.getElementById("navbar_container").style.left = "0px";
  }, []);
  const [iframeURL, setIframeURL] = useState("");
  const navigate = useNavigate();
  const [showContent, setShowContent] = useState(false);
  const { eventType, eventId, contentType } = useParams();
  const theme = useTheme();
  const registerAttendanceMutation = useRegisterAttendance();
  const eventInfoQuery = useEventInfo({
    eventType,
    eventId,
  });
  const isContentRewatchable = eventInfoQuery.data?.permite_rever === "S";
  const {
    eventIsHappening,
    eventHasEnded,
    checkInIsHappening,
    eventStartsAt,
    checkInWillHappen,
    checkInHasEnded,

    checkInStartAtDate,
    checkInEndsAtDate,
  } = eventMoments(eventInfoQuery.data);

  const { data } = useCheckInEventLink({
    eventType,
    eventId,
  });
  const openContent = async (nWindow) => {
    const link = eventInfoQuery.data?.contentURL || data?.link;
    if (link) {
      switch (contentType.toLocaleUpperCase()) {
        case "EXTERNAL":
          if (eventIsHappening || (eventHasEnded && isContentRewatchable)) {
            nWindow.location.href = link;
          }
          break;

        case "ZOOM":
          try {
            if (eventIsHappening || (eventHasEnded && isContentRewatchable)) {
              const zoomMeetingURL = await getZoomContent({
                eventId,
                eventType,
              });
              nWindow.location.href = zoomMeetingURL;
            }
          } catch (e) {
            createNotification({ type: "error", message: e });
          }
          break;
        default:
          setIframeURL(link);

          break;
      }
    }
    setShowContent(true);
  };
  const handleClickRegisterAttendance = () => {
    const newWindow = window.open(
      "about:blank",
      "blank",
      `width=1200,height=800,left=${(window.screen.width - 1200) / 2},top=${
        (window.screen.height - 800) / 2
      },menu=no,toolbar=no`
    );
    switch (contentType.toLocaleUpperCase()) {
      case "EXTERNAL":
      case "ZOOM":
        break;
      default:
        newWindow.close();
        break;
    }

    registerAttendanceMutation.mutate(
      { eventType, eventId },
      {
        onSuccess: () => {
          openContent(newWindow);
        },
        onError: (error) => {
          if (
            error.data?.message ===
              "Sua presença já havia sido registrada anteriormente!" ||
            (error.data?.message ===
              "Sua presença não foi registrada. Motivo: você não está matriculado ou a aula está fora do período de Checkin" &&
              isContentRewatchable)
          ) {
            openContent();
          }
        },
      }
    );
  };

  const buttonProps = () => {
    if (checkInHasEnded && eventHasEnded && isContentRewatchable) {
      return { text: "Rever conteúdo" };
    } else if (checkInIsHappening && !eventIsHappening) {
      return { text: "Registrar Presença" };
    } else if (eventIsHappening) {
      switch (eventType.toLocaleUpperCase()) {
        case "AULA":
          if (contentType.toLocaleUpperCase() === "PRESENCIAL") {
            return { text: "Registrar Presença" };
          }
          return { text: "Entrar na aula" };
        case "LIVE":
          return { text: "Entrar na live" };

        default:
          return { text: "Entrar no evento" };
      }
    } else if (!checkInIsHappening) {
      return { text: "Período de check-in encerrado" };
    } else {
      return { text: "Registrar Presença" };
    }
  };

  return (
    <div className="flex w-full h-[100dvh] bg-slate-300">
      <Navbar />
      {/* <PageContent sx={{ height: "100dvh" }}> */}
      <Container
        sx={{
          height: "100%",
          backgroundColor: theme.palette.grey[200],
          boxShadow: 3,
          overflow: { xs: "auto", md: "hidden" },
        }}
        disableGutters
        maxWidth={false}
      >
        {!showContent && (
          <Box component={"header"} className="p-4">
            <Button
              onClick={() => {
                navigate(-1);
              }}
            >
              Voltar
            </Button>
            <span className="flex flex-row gap-2 items-center p-2">
              <Avatar
                src={`${baseUrl}/Membros/fotos/${eventInfoQuery.data?.foto}`}
                sx={{ height: "64px", width: "64px" }}
              >
                {eventInfoQuery.data?.nome[0]}
              </Avatar>
              <Typography variant="h6">{eventInfoQuery.data?.nome}</Typography>
            </span>
            <Grid container sx={{ paddingLeft: "76px" }}>
              <Grid item xs={12} md={3}>
                <Typography variant="caption">
                  <span className="text-gray-500">Professor: </span>

                  {eventInfoQuery.data?.nome_professor}
                </Typography>
              </Grid>
              <Grid item xs={12} md={3}>
                <Typography variant="caption">
                  <span className="text-gray-500">Começa: </span>
                  {eventStartsAt.format(DATE_FORMAT)}
                </Typography>
                <br />
                <Typography variant="caption">
                  {" "}
                  <span className="text-gray-500">Duração: </span>
                  {eventInfoQuery.data?.live_duracao_aproximada_minutos} minutos
                </Typography>
              </Grid>
              <Grid item xs={12} md={3}>
                <Typography variant="caption">
                  <span className="text-gray-500">Check-in começa: </span>
                  {checkInStartAtDate.format(DATE_FORMAT)}
                </Typography>
                <br />
                <Typography variant="caption">
                  <span className="text-gray-500">Check-in encerra: </span>
                  {checkInEndsAtDate.format(DATE_FORMAT)}
                </Typography>
              </Grid>
            </Grid>
          </Box>
        )}

        <Box component={"main"} className="h-full">
          <PreRegisterWarnings
            contentType={contentType}
            url={iframeURL}
            eventMoments={eventMoments(eventInfoQuery.data)}
            eventInfo={eventInfoQuery.data}
          />
          {!showContent && eventInfoQuery.isSuccess && (
            <Button
              sx={{ display: "block", ml: "auto", mr: "auto", mt: 5 }}
              disabled={
                checkInWillHappen || (checkInHasEnded && !isContentRewatchable)
              }
              onClick={handleClickRegisterAttendance}
            >
              {buttonProps().text}
            </Button>
          )}

          {showContent && (
            <RenderContents
              contentType={contentType}
              url={iframeURL}
              eventType={eventType}
              eventMoments={eventMoments(eventInfoQuery.data)}
              eventInfo={eventInfoQuery.data}
              isContentRewatchable={isContentRewatchable}
            />
          )}
        </Box>
      </Container>
      {/* </PageContent> */}
    </div>
  );
};

export default AttendanceRegistrationpage;
